<style>
	@import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Products" title="Stock Logs" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-10">
										<div class="mm-cart-text">
											<div class="col-md-8">
												<table class="product_table">
													<thead style="font-size: medium;">
														<tr>
															<th>Product</th>
															<th style="text-align: left;">:</th>
															<td style="text-align: right;">{{ product.product_name }}</td>
														</tr>
														<tr>
															<th>Current Stock</th>
															<th style="text-align: left;">:</th>
															<td style="text-align: right;">{{ product.current_stock }}</td>
														</tr>
													</thead>
												</table>
												<img
													v-if="product.image"
													:src="$image_url + product.image"
													alt=""
													height="60"
													width="60"
													class="mt-2 rounded"
													style="object-fit: cover;"
												/>
											</div>
										</div>
									</div>
									<div class="col-md-2">
										<a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end">
											<i class="bx bx-chevrons-left"></i> Back
										</a>
									</div>
								</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-8 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<select class="form-select" v-model="listing_length" @change="fetchStockLogs()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
											<th>Sl.No</th>
											<th>Type</th>
											<th>Stock</th>
											<th>Balance Stock</th>
											<th>Technician</th>
											<th>Added By</th>
											<th>Updated On</th>
										</tr>
									</thead>
									<tbody v-if="Boolean(stockLogs.length)">
										<tr align="center" v-for="(log, index) in stockLogs" :key="log.id">
											<td>{{ from + index }}</td>
											<td>{{ typeLabel(log.type) }}</td>
											<td>{{ log.stock }}</td>
											<td>{{ log.balance_stock }}</td>
											<td>{{ log.technician_name || '—' }}</td>
											<td>{{ log.added_user_name || '—' }}</td>
											<td>{{ log.converted_created_at }}</td>
										</tr>
									</tbody>
									<tbody v-else>
										<tr>
											<td colspan="7" align="center">No data available</td>
										</tr>
									</tbody>
								</table>
							</div>

							<caption v-if="Boolean(stockLogs.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{ from }} to {{ to }} of {{ total }} entries</caption>
							<nav aria-label="Page navigation" class="mt-2 float-end">
								<ul class="pagination">
									<li
										class="page-item"
										v-bind:class="[{ disabled: !page.url }, { active: page.active }]"
										v-for="(page, index) in pagination"
										:key="page.label"
									>
										<a
											class="page-link"
											href="#"
											@click.prevent="fetchStockLogs(page.url + '&limit=' + listing_length + '&product_id=' + $route.params.id)"
											tabindex="-1"
										>
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav>

						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "ProductStockLogsPage",
	data() {
		return {
			keyword: "",
			listing_length: 10,
			token: "",
			product: {},
			stockLogs: [],
			pagination: [],
			from: 0,
			to: 0,
			total: 0,
			active_page_url: null,
		};
	},
	created() {
		this.fetchStockLogs();
	},
	methods: {
		getToken() {
			if (localStorage.getItem("airotrack_staff")) {
				const airotrack_staff = JSON.parse(localStorage.getItem("airotrack_staff"));
				if (airotrack_staff.token) {
					this.token = airotrack_staff.token;
				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}
			} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
			}
		},

		fetchStockLogs(page_url = null) {
			this.getToken();
			const url =
				"/staffs/stockLogs?limit=" +
				this.listing_length +
				"&product_id=" +
				this.$route.params.id;
			page_url = page_url || url;
			this.active_page_url = page_url;
			this.$axios
				.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
				.then((res) => {
					const responseData = res.data.data;
					this.product = responseData.product || {};
					const logs = responseData.stock_logs || {};
					this.stockLogs = logs.data || [];
					this.pagination = logs.links || [];
					this.from = logs.from || 0;
					this.to = logs.to || 0;
					this.total = logs.total || 0;
				})
				.catch((err) => console.log(err));
		},

		typeLabel(type) {
			const map = {
				1: "Add",
				2: "Debit",
			};
			return map[type] || "N/A";
		},
	},
};
</script>
